import React, { Component } from 'react';
import { CurrencyInput } from "components/dashboard/buy-and-sell/CurrencyInput";
import { images } from 'assets/img/dashboard/buy-and-sell/buy-and-sell';
import 'assets/sass/dashboard/deposits/withdraws/Amount.scss';
import { MoneyField, MoneyWithCurrencyField } from "buenLib/components/MoneyField";
import { AppContext } from 'app/state/AppContext';

export class WithdrawAmountStep extends Component {
    static contextType = AppContext;

    renderFeeText(form) {
        if (!!form.fee() && form.fee() > 0) {
            return <div className="fee-texts">
                <p className="fee-text">+ comisión de la red: <b><MoneyWithCurrencyField
                    value={form.fee().toString()}
                    currency={form.currency()}
                    defaultValue={'--'} /></b>.</p>
                <p className="total-withdraw-text">Total a descontar de tu saldo: <b
                    className={form.currency()}><MoneyWithCurrencyField
                        value={form.amountWithFee().toString()}
                        currency={form.currency()}
                        defaultValue={'--'} /></b></p>
            </div>;
        }
    }

    renderWithdrawLimitsMessage() {
        let minimumWithdrawAmount = this.props.withdrawForm.minimumAmount();
        let maximumWithdrawAmount = this.props.withdrawForm.maximumAmount();
        return <p className="withdraw-limits-message">
            <b>Retiro mínimo:</b> <MoneyWithCurrencyField currency={this.props.currency}
                value={minimumWithdrawAmount.toString()}
                defaultValue={"Sin mínimo"} />
            <br />
            <b>Retiro máximo:</b> <MoneyWithCurrencyField currency={this.props.currency}
                value={maximumWithdrawAmount.toString()}
                defaultValue={"Sin máximo"} />
        </p>;
    }

    render() {
        const form = this.props.withdrawForm;
        let currencyDisplayValue = form.currencyDisplayValue();
        let currencyDisplayValueCapitalized = currencyDisplayValue[0].toUpperCase() + currencyDisplayValue.substring(1);
        return (
            <div className="withdraw-amount">
                <div className="d-lg-none d-md-none mt-0 mb-5 justify-content-center buy-and-sell-balances">
                    <div className={`balance ${form.currency()}-balance`}>
                        <div className="balance-title">SALDO ACTUAL:
                            <img className="icon-currency" src={images[`${form.currency().lowercaseCode()}Ball`]} alt={form.currency().code()} />
                            <div className="balance-quantity">
                                <MoneyField value={this.props.balance[form.currency().lowercaseCode()]}
                                    currency={form.currency()}
                                    defaultValue={'--'} />
                            </div>
                        </div>
                    </div>
                </div>
                <p>{currencyDisplayValueCapitalized} a transferirle a <b>{form.walletAddress()}</b></p>
                <CurrencyInput currency={form.currency()}
                    name="amount"
                    field={form.amountField()}
                    handleChange={this.props.handleWithdrawAmountChange} />
                {this.renderFeeText(form)}

                <button className={"cta-button mt-3" + (this.props.canContinue ? '' : ' disabled')}
                    onClick={this.props.handleContinue}>
                    CONTINUAR RETIRO
                </button>
                {this.renderWithdrawLimitsMessage(form)}
                <br />
                <br />
                <button className="link-btn" onClick={this.props.handleGoBack}>Volver</button>
            </div>
        );
    }
}
